import { render } from "./CurrencyValue.vue?vue&type=template&id=57d8935d"
import script from "./CurrencyValue.vue?vue&type=script&lang=js"
export * from "./CurrencyValue.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__